import {
  Validator
} from 'vee-validate'

Validator.extend('require_protocol', {
  getMessage: () => 'The URL must start with https:// or http://.',
  validate: (url) => ['http://', 'https://'].some(protocol => url.startsWith(protocol))
})
